import { css, CSSResult } from 'lit'
import { csColorAction, csColorBackground } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csBorder, csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cseCarouselPagination = {
  navigationBackgroundColor: css`var(--cse-carousel-pagination-background-color, ${csColorBackground.secondary})`,

  sliderTrackBackgroundColor: css`var(--cse-carousel-pagination-slider-track-background-color, ${csColorBackground.secondary})`,
  sliderTrackBackgroundColorDisabled: css`var(--cse-carousel-pagination-slider-track-background-color-disabled, ${csColorBackground.disabled})`,
  sliderTrackHeight: css`var(--cse-carousel-pagination-slider-track-height, ${csSpacing.spacing04})`,
  sliderTrackWidth: css`var(--cse-carousel-pagination-slider-track-width, 200px)`,
  sliderFillBackgroundColor: css`var(--cse-carousel-pagination-slider-fill-background-color, ${csColorAction.secondary})`,
  sliderFillBackgroundColorDisabled: css`var(--cse-carousel-pagination-slider-fill-background-color-disabled, ${csColorBackground.disabled})`,
  sliderFillHeight: css`var(--cse-carousel-pagination-slider-fill-height, ${csSpacing.spacing04})`,
}

export const style: CSSResult = css`
  .carousel-controls {
    align-items: center;
    display: flex;
    gap: ${csSpacing.spacing05};
  }

  .navigation {
    border-radius: ${csBorder.radiusFull};
    background-color: ${cseCarouselPagination.navigationBackgroundColor};
    padding: ${csSpacing.spacing02};
    position: relative;
  }

  .carousel-pagination-item {
    align-items: center;
    background: ${csColorBackground.secondary};
    display: flex;
    height: 100%;
    padding-inline: ${csSpacing.spacing05};
    position: absolute;
    opacity: 0;
    top: 0;
    transform: translateX(0);
    transition-duration: ${csTransition.duration};
    transition-property: opacity transform;
    transition-timing-function: ${csTransition.timingFunction};
    width: fit-content;
    z-index: -1;
  }

  /*  animation  */
  .carousel-pagination-item__previous {
    border-bottom-left-radius: ${csBorder.radiusFull};
    border-top-left-radius: ${csBorder.radiusFull};
    left: 0;
    padding-right: 34px;
    padding-left: 13px;
  }

  .carousel-pagination-item__next {
    border-bottom-right-radius: ${csBorder.radiusFull};
    border-top-right-radius: ${csBorder.radiusFull};
    right: 0;
    padding-left: 34px;
    padding-right: 13px;
  }

  .carousel-pagination-previous:not([disabled]):hover + .carousel-pagination-item,
  .carousel-pagination-next:not([disabled]):hover + .carousel-pagination-item {
    opacity: 1;
  }

  .carousel-pagination-previous:not([disabled]):hover + .carousel-pagination-item__previous {
    transform: translateX(calc(-100% + 27px));
  }

  .carousel-pagination-next:not([disabled]):hover + .carousel-pagination-item__next {
    transform: translateX(calc(100% - 27px));
  }

  /* Slider */
  :host([variant='slider']),
  :host([variant='nav-slider']) {
    display: block;
    width: 100%;
  }

  .variant-slider,
  .variant-nav-slider {
    justify-content: center;
    width: 100%;
  }

  .carousel-slider-track {
    align-items: center;
    background-color: ${cseCarouselPagination.sliderTrackBackgroundColor};
    border-radius: ${csBorder.radiusFull};
    cursor: pointer;
    display: flex;
    height: ${cseCarouselPagination.sliderTrackHeight};
    position: relative;
    touch-action: none;
    width: ${cseCarouselPagination.sliderTrackWidth};
  }

  .carousel-slider-track:focus-visible {
    outline: ${csBorder.width} solid ${csColorAction.secondary};
    outline-offset: ${csSpacing.spacing02};
  }

  .carousel-slider-fill {
    background-color: ${cseCarouselPagination.sliderFillBackgroundColor};
    border-radius: ${csBorder.radiusFull};
    height: ${cseCarouselPagination.sliderFillHeight};
    min-width: ${cseCarouselPagination.sliderFillHeight};
    transition-duration: ${csTransition.duration};
    transition-property: width;
    transition-timing-function: ${csTransition.timingFunction};
  }

  .carousel-controls.disabled .carousel-slider-track {
    background-color: ${cseCarouselPagination.sliderTrackBackgroundColorDisabled};
    cursor: default;
    pointer-events: none;
  }

  .carousel-controls.disabled .carousel-slider-fill {
    background-color: ${cseCarouselPagination.sliderFillBackgroundColorDisabled};
  }
`
